import axios, { AxiosResponse } from "axios";

import { handleError } from "@utils/axios-utils";
import { axiosInstance } from "@utils/axiosInstance";

export const putData = async <TRequest = unknown, TResponse = unknown>(
  url: string,
  data?: TRequest
) => {
  try {
    const result = await axiosInstance.put<TRequest, AxiosResponse<TResponse>>(
      url,
      data
    );
    return result.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError(error);
    }
  }
};
